var registerComponent = require('../core/component').registerComponent;

/**
 * Physics component.
 */
module.exports.Component = registerComponent('physics', {
  schema: { default: 'none', oneOf: ['none', 'static', 'dynamic'] },

  init: function () {
    this.data = 'none';
    if (this.el.hasAttribute('static-body')) {
      this.data = 'static-body';
    } else if (this.el.hasAttribute('dynamic-body')) {
      this.data = 'dynamic-body';
    }
  },

  update: function () {
    switch (this.data) {
      case 'none': {
        if (this.el.hasAttribute('static-body')) {
          this.el.removeAttribute('static-body');
        }
        if (this.el.hasAttribute('dynamic-body')) {
          this.el.removeAttribute('dynamic-body');
        }
        break;
      }
      case 'static': {
        if (this.el.hasAttribute('dynamic-body')) {
          this.el.removeAttribute('dynamic-body');
        }
        if (!this.el.hasAttribute('static-body')) {
          this.el.setAttribute('static-body', '');
        }
        break;
      }
      case 'dynamic': {
        if (this.el.hasAttribute('static-body')) {
          this.el.removeAttribute('static-body');
        }
        if (!this.el.hasAttribute('dynamic-body')) {
          this.el.setAttribute('dynamic-body', '');
        }
        break;
      }
    }
    // this.el.setAttribute('physics', this.data);
  }
});
